import React, { useEffect, useState } from "react";
import Styles from "./ClientHeader.module.scss";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import clsx from "clsx";
import { NavLink, useNavigate } from "react-router-dom";
import { handleClientLogout } from "../Func/clientLogout";
import { notifyOpenClientProfile } from "../Func/Storage";
import useClientAuthSession from "../../Hooks/useClientAuthSession";
import {
  login,
  signup,
  manualdownload,
  subUrl,
  toHomePageUrl,
  // clientPayment,
} from "../../Api/SubUrl";
import { Path } from "../../Api/Path";
import { useRef } from "react";
function ClientHeader() {
  const navigate = useNavigate();
  const menuHorizontal = useRef();
  const handleClose = () => {
    menuHorizontal.current.click();
  };

  const handleLogout = (event) => {
    event.preventDefault();
    handleClose();
    handleClientLogout(() => navigate(login, { replace: true }));
  };

  const { isAuthenticated } = useClientAuthSession();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      className={clsx(Styles.Navbar, { [Styles.scrolled]: isScrolled })}
      bg="light"
      expand="lg"
    >
      <Container className={clsx(Styles.container)}>
        <Navbar.Brand className={clsx(Styles.brand)}>
          <NavLink
            className={clsx(Styles.BrandWrap)}
            to={login}
            onClick={() => {
              if (isAuthenticated) notifyOpenClientProfile();
            }}
          ></NavLink>
        </Navbar.Brand>

        <Navbar.Toggle
          className={clsx(Styles.btn)}
          aria-controls="basic-navbar-nav"
          ref={menuHorizontal}
        />

        <Navbar.Collapse
          id="basic-navbar-nav"
          className={clsx(Styles.menuHorizontalWrap)}
        >
          <Nav className={clsx(Styles.menuHorizontal, "me-auto")}>
            <a
              href={toHomePageUrl(subUrl)}
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
            >
              Trang chủ
            </a>

            <NavLink
              target="_blank"
              className={clsx(Styles.itemNav)}
              to={Path.Fanpage}
            >
              <span className={clsx(Styles.itemHover)} />
              Fanpage
            </NavLink>

            <a
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(Styles.itemNav)}
              href={toHomePageUrl(manualdownload)}
            >
              <span className={clsx(Styles.itemHover)} />
              Tải ngay
            </a>

            <NavLink
              onClick={() => {
                handleClose();
                if (isAuthenticated) notifyOpenClientProfile();
              }}
              className={clsx(Styles.itemNav)}
              to={login}
            >
              <span className={clsx(Styles.itemHover)} />
              {isAuthenticated ? "Tài khoản" : "Đăng nhập"}
            </NavLink>

            {isAuthenticated ? (
              <>
                <NavLink
                  onClick={handleLogout}
                  className={clsx(Styles.itemNav)}
                  to={login}
                >
                  <span className={clsx(Styles.itemHover)} />
                  Đăng xuất
                </NavLink>
              </>
            ) : null}

            <NavLink
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
              to={signup}
            >
              <span className={clsx(Styles.itemHover)} />
              Đăng ký
            </NavLink>
            <NavLink
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
              to={login}
            >
              <span className={clsx(Styles.itemHover)} />
              Nạp KNB
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ClientHeader;
